import React, { useCallback, useMemo } from "react";
import { IconButton, Paper } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { makeStyles } from "@mui/styles";

import { AgGridReact } from "ag-grid-react";

const useStyles = makeStyles(() => ({
    root: {
        "& .ag-header-cell": {
            backgroundColor: "#FAFAFA !important", //"#1976d2 !important",
            color: "red !important"
        },
        "& .ag-header-cell-label": {
            color: "#32363A !important",
            fontWeight: "600 !important"
        }
    }
    /*   fields: {
           backgroundColor: "red !important"
       }*/
}));

// const useStyles = makeStyles(styles);
export default function MaintenanceTable({
    columns,
    rows,
    onEdit,
    onDelete,
    resource
}) {
    const classes = useStyles();

    // set background colour on every row, this is probably bad, should be using CSS classes
    const rowStyle = useMemo(() => {
        return { background: "rgb(237 246 255 / 50%)" };
    }, []);

    // set background colour on even rows again, this looks bad, should be using CSS classes
    const getRowStyle = useCallback((params) => {
        if (params.node.rowIndex % 2 === 0) {
            return { background: "#FfFF" };
        }
    }, []);

    const cellRenderer = ({ data }) => {
        return (
            <div style={{ display: "flex", gap: "8px" }}>
                <IconButton size="small" onClick={() => onEdit(data)}>
                    <EditIcon fontSize="small" />
                </IconButton>

                <IconButton
                    size="small"
                    color="error"
                    onClick={() => onDelete(data)}
                >
                    <DeleteIcon fontSize="small" />
                </IconButton>
            </div>
        );
    };

    /*    const colDefs = [
            ...columns.map((column) => ({
                field: column.field,
                editable: !!column.editable,
                headerName: column.header
            })),
            {
                headerName: "Actions",
                field: "actions",
                width: 100,
                flex: 0,
                cellRenderer
            }
        ];*/

    const colDefs = [
        ...columns.map((column) => {
            const baseColDef = {
                field: column.field,
                editable: !!column.editable,
                headerName: column.header
            };

            if (column.type === "select") {
                const valueToLabel = (column.options || []).reduce(
                    (acc, opt) => {
                        acc[opt.value] = opt.label;
                        return acc;
                    },
                    {}
                );

                return {
                    ...baseColDef,
                    valueFormatter: (params) =>
                        valueToLabel[params.value] ?? params.value
                };
            }

            if (column.type === "date") {
                return {
                    ...baseColDef,
                    valueFormatter: (params) => {
                        if (!params.value) return "";
                        const d = new Date(params.value);
                        return isNaN(d) ? params.value : d.toLocaleDateString();
                    }
                };
            }

            if (column.type === "number" || column.type === "decimal") {
                return {
                    ...baseColDef,
                    cellDataType: "number", // ensures right-alignment + numeric sorting
                    valueFormatter: (params) => {
                        if (
                            params.value === null ||
                            params.value === undefined ||
                            params.value === ""
                        ) {
                            return "";
                        }
                        const num = Number(params.value);
                        if (isNaN(num)) return params.value;

                        // decimal -> fixed 2 places, number -> integer with thousands separators
                        return column.type === "decimal"
                            ? num.toLocaleString(undefined, {
                                  minimumFractionDigits: column.decimals ?? 2,
                                  maximumFractionDigits: column.decimals ?? 2
                              })
                            : num.toLocaleString();
                    }
                };
            }

            return baseColDef;
        }),
        {
            headerName: "Actions",
            field: "actions",
            width: 100,
            flex: 0,
            cellRenderer
        }
    ];

    /*const rowData = rows.map((row) => ({
        ...columns.reduce(
            (acc, key) => ({ ...acc, [key.field]: row[key.field] }),
            {}
        ),
        row
    }));*/

    const defaultColDef = {
        flex: 1
    };

    return (
        <Paper variant="outlined">
            <div
                style={{
                    width: "100%"
                }}
                // className={classes.root}
                className={`${classes.root} ag-theme-alpine`}
            >
                <AgGridReact
                    rowData={rows}
                    columnDefs={colDefs}
                    defaultColDef={defaultColDef}
                    singleClickEdit={true}
                    domLayout="autoHeight"
                    enableClickSelection={true}
                    rowStyle={rowStyle}
                    getRowStyle={getRowStyle}
                    suppressCellFocus={true}
                    getRowId={(params) => params.data.rowId || params.data.id}
                    // rowSelection={rowSelection}
                />
            </div>
        </Paper>
    );
}
